/* eslint-disable react/display-name */
import React from 'react';

export const CanvasWrapper = React.memo(() => {
	return <canvas className="output_canvas" id="output_canvas"></canvas>;
});
